import { http } from '@/utils/request';
import { parseResponse } from './common';

/**
 * 获取当前用户信息
 * @param {Object} config - 配置参数
 * @param {boolean} config.showLoading - 是否显示全局 loading，默认为 true
 * @returns {Promise<Object>} 用户信息
 */
export const getCurrentUserService = async (config = {}) => {
  const { showLoading = true, ...otherConfig } = config;
  const url = '/api/erp/v1/auth/currentUser';
  const response = await http.get(url, {
    ...otherConfig,
    headers: {
      ...otherConfig.headers,
      'X-Show-Loading': showLoading.toString(),
    },
  });

  const result = parseResponse(response);

  // token 更新现在由响应拦截器统一处理，这里不需要重复处理

  return result;
};

/**
 * 登录 ERP 后端系统
 * @param {string} tenantName - 租户名
 * @param {string} username - 用户名
 * @param {string} password - 密码
 * @param {Object} config - 配置参数
 * @param {boolean} config.showLoading - 是否显示全局 loading，默认为 true
 * @returns {Promise<Object>} 登录结果，包含 token 和 user 信息
 */
export const loginErpBackendService = async (tenantName, username, password, config = {}) => {
  try {
    const { showLoading = true, ...otherConfig } = config;
    const url = '/api/erp/v1/auth/login';
    const response = await http.post(
      url,
      {
        name: username,
        password,
        tenantName,
      },
      {
        ...otherConfig,
        headers: {
          ...otherConfig.headers,
          'X-Show-Loading': showLoading.toString(),
        },
      }
    );
    return parseResponse(response);
  } catch (error) {
    console.error('ERP 后端登录失败:', error);
    throw new Error(error.message || 'ERP 后端登录失败');
  }
};
